import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const successNotificationAlert = () => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reconnect.aiReconnectModal.alerts.success.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reconnect.aiReconnectModal.alerts.success.text"
    }),
    type: 'success',
    sticky: false
  });
};
export const errorNotificationAlert = () => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reconnect.aiReconnectModal.alerts.error.invalidApiKey.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reconnect.aiReconnectModal.alerts.error.invalidApiKey.text"
    }),
    type: 'danger',
    sticky: false
  });
};